import { styled } from "styled-components";
import { theme } from "theme";

export const ConfirmationDialog = styled.div`
  .confirmation-dialog-content {
    padding: ${theme.spacing(3)};
    text-align: center;

    .confirmation {
    }
    .confirmation-icon {
      margin-bottom: ${theme.spacing(2)};
      font-size: 3rem;
    }

    .confirmation-message {
      margin-bottom: ${theme.spacing(3)};
      line-height: 1.6;
    }
  }
`;
